<script setup>
import { getI18n } from '@/plugins/i18n'

import { useDetectDevice } from '@/composables/device'

import NavigateBack from '@/components/shared/NavigateBack.vue'

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  caption: {
    type: String,
    default: null,
  },
  icon: {
    type: String,
    default: null,
  },
  floating: {
    type: Boolean,
    default: false,
  },
  docked: {
    type: Boolean,
    default: true,
  },
})

const emit = defineEmits(['move', 'update:docked', 'close'])

const i18n = getI18n()
const { isMobile } = useDetectDevice()

const onPan = ({ delta, isFinal }) => {
  if (props.floating) emit('move', { delta, isFinal })
}
</script>

<template>
  <div
    v-touch-pan.prevent.mouse="onPan"
    class="dockable-panel-header"
    :class="{ 'dockable-panel-header--floating': floating }"
  >
    <navigate-back
      hide-back
      :text-icon="icon"
      :text="title"
      :caption="caption"
    >
      <template #right>
        <div class="row no-wrap items-center">
          <slot name="actions" />
          <q-btn
            v-if="!isMobile"
            flat
            round
            dense
            :icon="docked ? 'mdi-dock-window' : 'mdi-dock-right'"
            @click="emit('update:docked', !docked)"
          >
            <q-tooltip>{{ i18n.t(docked ? 'common.undock' : 'common.dock') }}</q-tooltip>
          </q-btn>
          <q-btn
            flat
            round
            dense
            icon="mdi-close"
            @click="emit('close')"
          />
        </div>
      </template>
    </navigate-back>
  </div>
</template>

<style scoped lang="scss">
.dockable-panel-header {
  flex: none;
  :deep(.text) {
    align-items: stretch;
    justify-content: center;
    min-width: 0;
  }
  :deep(.navigate-back__title) {
    min-width: 0;
    .column {
      min-width: 0;
    }
    .q-item__label.text-h6 {
      font-size: 1rem;
      font-weight: 600;
      line-height: 1.3;
      overflow-wrap: anywhere;
    }
    .q-item__label--caption {
      margin-top: .125rem;
      color: $grey-6;
    }
  }
  :deep(.q-item__section--avatar:last-child) {
    min-width: 0;
    padding-right: 0;
  }
}

.dockable-panel-header--floating {
  cursor: move;
  user-select: none;
}
</style>
